import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { ReactComponent as Arrow } from '../../../images/icons/arrow.svg';
import ContentfulImage from '../../Common/ContentfulImage';
import { PrimaryLink } from '../../Common/Links';
import SmartLink from '../../Common/SmartLink';
import BeefSammy from './BeefSammy';
import * as styles from './Header.module.css';
import * as ms from './MobileStyles.module.css';

const MobileNav = ({ items }) => {
  const [state, setState] = useState({
    navOpen: false,
    subOpen: '',
  });

  useEffect(() => {
    if (!state.navOpen) document.body.removeAttribute('style');
  }, []); //eslint-disable-line

  // toggles menu state
  const toggleNav = () => {
    document.body.setAttribute('style', state.navOpen ? '' : 'overflow: hidden');
    setState({ ...state, navOpen: !state.navOpen });
  };

  const toggleSubNav = (title) => {
    setState({ ...state, subOpen: title });
  };

  const menu = items.map((item, i) => {
    const subNav = item.menuItems;
    return (
      <li key={i} className={[styles.menuItem, ms.menuItem].join(' ')}>
        {item.url && (
          <SmartLink className={[styles.menuItemLink, ms.menuItemLink].join(' ')} to={item.url}>
            {item.title}
          </SmartLink>
        )}
        {!item.url && (
          <button onClick={() => toggleSubNav(item.title)} className={[styles.menuItemLink, ms.menuItemLink].join(' ')}>
            <span className={ms.btnText}>{item.title}</span>
            <span className={ms.openArrow}>
              <Arrow />
            </span>
          </button>
        )}
        {!item.url && item.menuStyle === 'Rows' && (
          <>
            {subNav && (
              <ul
                className={[ms.subNav, 'unstyled-list'].join(' ')}
                aria-hidden={item.title !== state.subOpen}
                data-active={item.title === state.subOpen}
              >
                <li className={[styles.menuItem, ms.menuItem].join(' ')}>
                  <button
                    className={[styles.menuItemLink, ms.menuItemLink, ms.close].join(' ')}
                    onClick={() => toggleSubNav('')}
                  >
                    <span className={ms.closeArrow}>
                      <Arrow />
                    </span>
                    <span className={ms.btnText}>{item.title}</span>
                  </button>
                </li>
                {subNav.map((sub, s) => {
                  //must be before link or button for css reasons
                  const subChild = sub.subMenuItems;
                  return (
                    <li className={[styles.menuItem, ms.menuItem].join(' ')} key={s}>
                      {!sub.url ? (
                        <span className={[styles.menuItemLink, ms.menuItemLink].join(' ')}>{sub.title}</span>
                      ) : (
                        <SmartLink to={sub.url} className={[styles.menuItemLink, ms.menuItemLink].join(' ')}>
                          {sub.title}
                          {/* <p className={styles.itemDesc}>{sub.descriptionText}</p> */}
                        </SmartLink>
                      )}
                      {subChild && (
                        <ul className={'unstyled-list'}>
                          {subChild.map((child, c) => {
                            return (
                              <li className={[styles.menuItem, ms.menuItem].join(' ')} key={c}>
                                <div className={ms.linkRow}>
                                  <ContentfulImage className={styles.svgImg} imageFragment={child.icon} />
                                  &nbsp;&nbsp;
                                  <SmartLink to={child.url} className={[styles.menuItemLink].join(' ')}>
                                    {child.title}
                                    <p className={styles.itemDesc}>{child.description}</p>
                                  </SmartLink>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </>
        )}
        {!item.url && item.menuStyle === 'List' && (
          <>
            {subNav && (
              <ul
                className={[ms.subNav, 'unstyled-list'].join(' ')}
                aria-hidden={item.title !== state.subOpen}
                data-active={item.title === state.subOpen}
              >
                <li className={[styles.menuItem, ms.menuItem].join(' ')}>
                  <button
                    className={[styles.menuItemLink, ms.menuItemLink, ms.close].join(' ')}
                    onClick={() => toggleSubNav('')}
                  >
                    <span className={ms.closeArrow}>
                      <Arrow />
                    </span>
                    <span className={ms.btnText}>{item.title}</span>
                  </button>
                </li>
                {subNav.map((sub, s) => {
                  return (
                    <li className={[styles.menuItem, ms.menuItem].join(' ')} key={s}>
                      <div className={ms.linkList}>
                        <ContentfulImage className={styles.svgImg} imageFragment={sub.icon} />
                        &nbsp;&nbsp;
                        <SmartLink to={sub.url} className={[styles.menuItemLink].join(' ')}>
                          {sub.title}
                          <p className={styles.itemDesc}>{sub.description}</p>
                        </SmartLink>
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </>
        )}
        {!item.url && item.menuStyle === 'Stacked Columns' && (
          <>
            {subNav && (
              <ul
                className={[ms.subNav, 'unstyled-list'].join(' ')}
                aria-hidden={item.title !== state.subOpen}
                data-active={item.title === state.subOpen}
              >
                <li className={[styles.menuItem, ms.menuItem].join(' ')}>
                  <button
                    className={[styles.menuItemLink, ms.menuItemLink, ms.close].join(' ')}
                    onClick={() => toggleSubNav('')}
                  >
                    <span className={ms.closeArrow}>
                      <Arrow />
                    </span>
                    <span className={ms.btnText}>{item.title}</span>
                  </button>
                </li>
                {subNav.map((sub, s) => {
                  if (!sub.subMenuItems)
                    return (
                      <li className={[styles.menuItem, ms.menuItem].join(' ')} key={s}>
                        <div className={ms.linkList}>
                          <ContentfulImage className={styles.svgImg} imageFragment={sub.icon} />
                          &nbsp;&nbsp;
                          <SmartLink to={sub.url} className={[styles.menuItemLink].join(' ')}>
                            {sub.title}
                            <p className={styles.itemDesc}>{sub.description}</p>
                          </SmartLink>
                        </div>
                      </li>
                    );
                  return (
                    <li className={[styles.menuItem, ms.menuItem].join(' ')} key={s}>
                      {!sub.url ? (
                        <span className={[styles.menuItemLink, ms.menuItemLink].join(' ')}>{sub.title}</span>
                      ) : (
                        <SmartLink to={sub.url} className={[styles.menuItemLink, ms.menuItemLink].join(' ')}>
                          {sub.title}
                        </SmartLink>
                      )}
                      {sub.subMenuItems && (
                        <ul className={'unstyled-list'}>
                          {sub.subMenuItems.map((child, c) => {
                            return (
                              <li className={[styles.menuItem, ms.menuItem].join(' ')} key={c}>
                                <div className={ms.linkRow}>
                                  <ContentfulImage className={styles.svgImg} imageFragment={child.icon} />
                                  &nbsp;&nbsp;
                                  <SmartLink to={child.url} className={[styles.menuItemLink].join(' ')}>
                                    {child.title}
                                    <p className={styles.itemDesc}>{child.description}</p>
                                  </SmartLink>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </>
        )}
      </li>
    );
  });
  return (
    <>
      <nav className={ms.mobileNav} aria-hidden={!state.navOpen} data-active={state.navOpen}>
        <div className={ms.container}>
          <ul className={[ms.mainNav, 'unstyled-list'].join(' ')}>{menu}</ul>
          {state.subOpen === '' && (
            <ul className={[styles.ctaNav, ms.ctaNav, 'unstyled-list'].join(' ')}>
              <>
                <li>
                  <SmartLink to="/ui">Login</SmartLink>
                </li>
                <li>
                  <PrimaryLink url="/demo" isButton label="Get a demo" />
                </li>
              </>
            </ul>
          )}
        </div>
      </nav>

      <BeefSammy onClick={toggleNav} open={state.navOpen} />
    </>
  );
};

MobileNav.propTypes = {
  items: PropTypes.any,
};

export default MobileNav;
